/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs */

const en_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for always being here with us.`)
};

const ar_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شكرًا لك على وجودك معنا دائمًا.`)
};

const de_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danke, dass Sie immer für uns da sind.`)
};

const es_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gracias por estar siempre con nosotros.`)
};

const fr_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci d'être toujours présent(e) à nos côtés.`)
};

const it_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie per essere sempre qui con noi.`)
};

const ja_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつも森を育ててくれて、ありがとうございます。`)
};

const ko_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`항상 Forest와 함께 해주셔서 감사해요.`)
};

const pt_br_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agradecemos por sempre estar aqui conosco.`)
};

const ru_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спасибо, что всегда остаётесь с нами!`)
};

const th_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขอบคุณที่อยู่เคียงข้างเรามาโดยตลอด`)
};

const tr_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her zaman yanımızda olduğun için teşekkür ederiz.`)
};

const zh_cn_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`谢谢你一直都在。`)
};

const zh_tw_pro_user_appreciation_letter_bald_cypress_body4 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`謝謝你一直都在。`)
};

/**
* | output |
* | --- |
* | "Thank you for always being here with us." |
*
* @param {Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_bald_cypress_body4 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Bald_Cypress_Body4Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_bald_cypress_body4(inputs)
	return zh_tw_pro_user_appreciation_letter_bald_cypress_body4(inputs)
});